import {
    isInternational
} from '../global/_checkForInternational';

export const removeIntlATB = () => {
    if (isInternational() && $('#preorder-alert').length > 0) {
        if ($('#preorder-alert').html().indexOf('international')) $('.quickViewActions').hide();
    }
}
